export default __webpack_public_path__ + "static/media/apc-hover.39b20f0b.svg";